import { createApp } from 'vue/dist/vue.esm-bundler';

import Hero from './twig/components/hero/Hero.vue';
import Video from './twig/components/video/Video.vue';
import Modal from './twig/components/modal/Modal.vue';
import ModalBtn from './twig/components/modal/ModalBtn.vue';

import './styles/styles.scss';

const app = createApp({
  components: {
    Hero,
    Video,
    Modal,
    ModalBtn,
  },
});

app.mount('#app');
